import React, { useContext, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import { useHistory } from 'react-router-dom'
import Typography from '../../Typography'
import styles from './DownloadImage.module.sass'
import { Order } from '../../../models'
import routes from '../../../routes'
import { CustomerContext } from '../../../contexts/CustomerContext'
import OrderStatusForm from "../OrderStatus/OrderStatusForm";

const DownloadImageForm = () => {
  const history = useHistory()
  const { customer, setCustomer } = useContext(CustomerContext)
  const [orderId, setOrderId] = useState('')
  const [email, setEmail] = useState('')
  const [studentFirstName, setStudentFirstName] = useState('')
  const [studentLastName, setStudentLastName] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = (e) => {
    e.preventDefault();

    const errorMsg = `We couldn't find your images with the provided information. Please contact us if you have trouble finding your images.`

    if (!orderId) {
      toast.error('Please enter your Order ID to download your images.')
      return
    }

    setIsLoading(true)

    if (orderId) {
      Order
        .includes({ cart: { orderPackages: 'student' } })
        .where({ id: orderId, email })
        .first()
        .then((res) => {
          if (res.data) {
            setCustomer({ ...customer, currentStudent: res.data.cart.orderPackages[0].student })
            history.push(routes.downloadImage(res.data.id, email))
          } else {
            toast.error(errorMsg)
            setIsLoading(false)
          }
        })
        .catch((err) => {
          toast.error(errorMsg)
          setIsLoading(false)
        })
        .finally(() => setIsLoading(false))
    } else {
      Order
        .includes({ cart: { orderPackages: 'student' } })
        .where({ email })
        .where({ forStudentName: [studentFirstName, studentLastName] })
        .order({ createdAt: 'desc' })
        .first()
        .then((res) => {
          if (res.data) {
            setCustomer({ ...customer, currentStudent: res.data.cart.orderPackages[0].student })
            history.push(routes.downloadImage(res.data.id, email))
          } else {
            toast.error(errorMsg)
            setIsLoading(false)
          }
        })
        .catch(() => {
          toast.error(errorMsg)
          setIsLoading(false)
        })
        .finally(() => setIsLoading(false))
    }
  }

  return (
    <>
      <ToastContainer />
      <div className={styles.container}>
        <OrderStatusForm
          onSubmit={onSubmit}
          setExternalOrderId={setOrderId}
          setExternalStudentFirstName={setStudentFirstName}
          setExternalStudentLastName={setStudentLastName}
          setExternalEmail={setEmail}
          requireOrderId
        />
      </div>
    </>
  )
}

export default DownloadImageForm
